import styled from '@emotion/styled';
import { Button, Dialog, DialogActions } from '@material-ui/core';
import { Mail, Slack } from 'lucide-react';
import React from 'react';
import { DialogContentWithoutPadding } from '../../../../components/DialogContentWithoutPadding';
import { ReactComponent as TeamsIcon } from '../../../../icons/microsoft_teams_icon.svg';
import { FlexContainer } from '../../../../layout/Flex';

const DialogHeader = styled('div')((p) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: `${p.theme.spacing(4)}px ${p.theme.spacing(5)}px ${p.theme.spacing(
    0
  )}px ${p.theme.spacing(5)}px`,
  width: '100%'
}));

const ChildrenContainer = styled('div')((p) => ({
  padding: p.theme.spacing(4)
}));

// This is not implemented properly atm - it just shows a bunch of icons, without actually
// looking at which channels are there.
// Disable until fixed.
const SHOW_CHANNEL_ICONS = false;

export const CardItemDialog: React.FC<{
  open: boolean;
  onClose: () => void;
  headerLeft?: React.ReactNode;
  dialogTable?: React.ReactNode;
}> = ({ open, onClose, headerLeft, dialogTable }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={'lg'} fullWidth>
      <DialogHeader>
        {headerLeft}
        {SHOW_CHANNEL_ICONS && (
          <FlexContainer marginBottom={2.5}>
            <Mail size={24} strokeWidth={1.5} />
            <Slack size={24} strokeWidth={1.5} />
            <TeamsIcon height={24} width={24} strokeWidth={1.5} />
          </FlexContainer>
        )}
      </DialogHeader>
      <DialogContentWithoutPadding fullHeight>
        <ChildrenContainer>{dialogTable}</ChildrenContainer>
      </DialogContentWithoutPadding>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
